import React, { Component } from 'react';
import _ from 'lodash';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import Select from 'react-select';
import { gql } from '@apollo/client';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import Modal from '../../components/modals';
import LoadingBar from '../../components/global/loadingBar';
import { toast } from 'react-toastify';
const getEvent = gql`
	query RootQuery($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			projectTitle

			name

			crew {
				count
				managerIds
				role
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			equipments {
				eqId
				qrCode
				status
				manufacturerId
				isReceived
				userName
				userId
				createdAt
				receivedAt
				logId
				description
				isRemapped
			}
			unregisteredEqs {
				_id
				status
				manufacturerId
				isReceived
				createdAt
				receivedAt
				description
				quantity
				receivedQuantity
				id
			}
		}
	}
`;
const getTenantUsersList = gql`
	query TenantUsersList($workspaceIds: [String!]!) {
		tenantUsersList(workspaceIds: $workspaceIds) {
			id
			firstName
			lastName
			email
			isEmailVerified
		}
	}
`;
const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			model
			description
			manufacturer
			manufacturerId
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdBy
			createdAt
			updatedBy
			updatedAt
			branch {
				_id
				branchId
			}
		}
	}
`;
const receiveEquipmentMutation = gql`
	mutation AssignEquipment(
		$workspaceId: String!
		$qrCodes: [String!]!
		$receivedFrom: LogUserInput!
		$projectId: ID
		$eventId: ID
	) {
		receiveEquipment(
			workspaceId: $workspaceId
			qrCodes: $qrCodes
			receivedFrom: $receivedFrom
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const receiveUnRegisteredEquipmentMutation = gql`
	mutation ReceiveUnregisteredEq(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$unregisteredEqs: [ReceiveUnregisteredEqInput]
	) {
		receiveUnregisteredEq(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			unregisteredEqs: $unregisteredEqs
		) {
			message
		}
	}
`;
class AsssignEquipment extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			actionType: 'receive',
			isLoading: true,
			qrCode: '',
			qrCodeError: false,
			qrCodeDuplicate: false,
			assignedCrew: null,
			tenantUsersList: {},
			eventDetails: {},
			equipments: [],
			unregisteredEquipmentsForQuery: [],
			receiveError: false,
			showBusyModal: false,
			confirmRemap: false,
		};
		this.timeout = 0;
	}
	unregisteredCount = 0;

	componentDidMount = () => {
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let filters2 = {
			workspaceIds: [this.props.params.workspaceID],
		};

		this.getShootInfo(getEvent, filters);
		this.getTenantUsersList(getTenantUsersList, filters2);
	};
	renderCrew = () => {
		let crewDetails = [];
		_.map(this.state.eventDetails.crewNew, (crew) => {
			if (crew.isCustomUser !== true && crew.userId !== null) {
				let name = '';
				let isManager = false;
				let found = undefined;
				found = _.find(this.state.tenantUsersList, { id: crew.userId });
				if (found) {
					name = `${found.firstName ? found.firstName : ''}${' '}${
						found.lastName ? found.lastName : ''
					}`;
					isManager = crew.isManager === null ? false : crew.isManager;
				}
				let data = { id: crew.userId, name, isManager };

				crewDetails.push(data);
			}

			return crew;
		});

		let arr = [];
		_.forEach(crewDetails, (item, key) => {
			arr.push({ value: item.id, label: item.name });
		});
		return (
			<Select
				className={`cost-select-container zIndex3 w-100p `}
				classNamePrefix="cost-select"
				onChange={(e) => this.handleEditCrewName(e)}
				isSearchable={true}
				options={arr}
				value={
					_.filter(arr, {
						value: this.state.assignedCrew,
					})[0]
				}
			/>
		);
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedCrew: e.value,
			assignedCrewUserName: e.label,
		});
	};

	recieveUnregisteredEquipment = async (equipment) => {
		if (!_.has(equipment, 'qrCode')) {
			this.unregisteredCount += 1;
			equipment['qrCode'] = `UNREGISTEREDEQ${this.unregisteredCount}`;
		}
		this.setState({
			//eventDetails,
			//unregisteredEquipmentsForQuery,
			equipments: [...this.state.equipments, equipment],
		});
	};
	handleEventChange = async (e, name) => {
		this.setState(
			{
				qrCode: e.target.value.trim(),
				qrCodeError: false,
				qrCodeDuplicate: false,
				receiveError: false,
				qrCodeNotAvailable: false,
			},
			() => {
				if (this.timeout) clearTimeout(this.timeout);
				this.timeout = setTimeout(async () => {
					if (
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value,
							}),
						) > 0 ||
						_.size(
							_.filter(this.state.equipments, {
								manufacturerId: e.target.value,
							}),
						) > 0
					) {
						this.setState({
							qrCodeError: true,
							qrCodeErrorMessage: 'Equipments already Scanned',
						});
					} else if (
						e.target.value !== '' &&
						e.target.value.length >= 4 &&
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value,
							}),
						) == 0
					) {
						let json = { eqIdentifier: e.target.value };
						await this.getEquipmentInfo(getEquipment, json, true);
					}
				}, 1000);
			},
		);

		// if (
		//     e.target.value != '' &&
		//     _.size(
		//         _.filter(this.state.eventDetails.equipments, {
		//             qrCode: e.target.value.trim(),
		//         })
		//     ) === 0
		// ) {
		//     this.setState({
		//         qrCodeNotAvailable: true,
		//     })
		// } else
	};
	renderSummary = () => {
		let data = _.filter(this.state.eventDetails.equipments, {
			isReceived: false,
		});

		let dataUnRegister = _.compact(
			_.map(this.state.eventDetails.unregisteredEqs, (equipment) =>
				equipment.quantity !== equipment.receivedQuantity ? equipment : undefined,
			),
		);
		return _.size(data) > 0 || _.size(dataUnRegister) > 0 ? (
			<div className="assign-hdd-item ">
				<div className="column column-20w">
					<span>QR Code</span>
					<span>Serial Number</span>
					<span>description</span>
					<span></span>
					{/* <span>damage</span> */}
				</div>
				{_.map(data, (equipment, key) => {
					if (
						_.size(
							_.filter(this.state.equipments, {
								qrCode: equipment.qrCode,
							}),
						) === 0
					)
						return (
							<div
								className="hitem column-20w listHitem"
								style={{
									//color: equipment.status === 'busy' ? 'orange' : '#fff',
									color: '#fff',
								}}
							>
								<span>{equipment.qrCode}</span>

								<span>{equipment.manufacturerId}</span>
								<span>{equipment.description}</span>
								{_.has(equipment, 'qrCode') ? (
									<span></span>
								) : (
									<span
										onClick={() =>
											this.recieveUnregisteredEquipment(
												_.cloneDeep(equipment),
											)
										}
									>
										move
									</span>
								)}
							</div>
						);
				})}

				{_.map(dataUnRegister, (equipment, key) => {
					let array = Array(
						(equipment.quantity < 0 ? 0 : equipment.quantity) -
							(equipment.receivedQuantity ? equipment.receivedQuantity : 0) -
							_.size(
								_.filter(this.state.equipments, {
									_id: equipment._id,
								}),
							),
					);

					return _.map(array, (arr) => {
						return (
							<div
								className="hitem column-20w listHitem"
								style={{
									//color: equipment.status === 'busy' ? 'orange' : '#fff',
									color: '#fff',
								}}
							>
								<span>{equipment.qrCode}</span>
								<span>{equipment.manufacturerId}</span>{' '}
								<span>{equipment.description}</span>
								{_.has(equipment, 'qrCode') ? (
									<span></span>
								) : (
									<span
										onClick={() =>
											this.recieveUnregisteredEquipment(
												_.cloneDeep(equipment),
											)
										}
									>
										move
									</span>
								)}
							</div>
						);
					});
				})}
			</div>
		) : (
			''
		);
	};
	isDisabled = () => {
		let busyEqs = [];
		_.map(this.state.equipments, (eq, key) => {
			if (
				_.has(eq, 'qrCode') &&
				!eq.qrCode.includes('UNREGISTEREDEQ') &&
				_.size(
					_.filter(this.state.eventDetails.equipments, {
						qrCode: eq.qrCode,
					}),
				) == 0
			) {
				busyEqs.push(eq);
			}
		});
		if (
			_.size(this.state.equipments) == 0 ||
			this.state.assignedCrew == null ||
			(_.size(busyEqs) > 0 && this.state.confirmRemap == false)
		) {
			return true;
		} else {
			return false;
		}
	};
	handleAssignEquipment = async (e) => {
		let eventId = this.props.params.shootID;
		let projectId = this.props.params.projectID;
		let workspaceId = this.props.params.workspaceID;

		let equipments = _.map(this.state.equipments, (equipment) => {
			if (equipment.qrCode.includes('UNREGISTEREDEQ')) {
				delete equipment['qrCode'];
			}
			return equipment;
		});

		equipments = _.compact(
			_.map(equipments, (equipment) => (_.has(equipment, 'qrCode') ? equipment : undefined)),
		);

		let qrCodes = [];
		_.forEach(equipments, (equipment, key) => {
			qrCodes.push(equipment.qrCode);
		});
		let json = {
			qrCodes: qrCodes,
			receivedFrom: {
				id: this.state.assignedCrew,
				name: this.state.assignedCrewUserName,
			},
			eventId,
			projectId,
			workspaceId,
		};

		equipments = _.compact(
			_.map(this.state.equipments, (equipment) =>
				!_.has(equipment, 'qrCode') ? equipment : undefined,
			),
		);

		let unregisteredEqs = [];
		_.forEach(equipments, (equipment) => {
			let index = _.findIndex(unregisteredEqs, { id: equipment._id });
			if (index === -1) {
				unregisteredEqs.push({
					id: equipment._id,
					quantity: 1,
				});
			} else {
				unregisteredEqs[index].quantity = unregisteredEqs[index].quantity + 1;
			}
		});

		let jsonUnRegister = {
			unregisteredEqs: unregisteredEqs,
			receivedFrom: {
				id: this.state.assignedCrew,
				name: this.state.assignedCrewUserName,
			},
			eventId,
			projectId,
			workspaceId,
		};

		let resp =
			_.size(qrCodes) > 0
				? await this.assignEquipment(receiveEquipmentMutation, json)
				: [true];
		let respUnRegister =
			_.size(unregisteredEqs) > 0
				? await this.assignEquipment(receiveUnRegisteredEquipmentMutation, jsonUnRegister)
				: [true];

		if (resp[0] == false) {
			toast.error(
				_.has(resp[1], 'message') ? resp[1]['message'] : 'Failed to Recieve Equipments',
				{
					position: 'top-right',
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
				},
			);
		} else if (respUnRegister[0] == false) {
			toast.error(
				_.has(respUnRegister[1], 'message')
					? respUnRegister[1]['message']
					: 'Failed to Recieve Unregistered Equipments',
				{
					position: 'top-right',
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
				},
			);
		} else {
			toast.success('Equipment Received successfully!', {
				position: 'top-right',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			this.props.navigate(
				`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
			);
		}
	};

	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	goBack = (e) => {
		this.props.navigate(`/${this.props.params.vendorID}/shoots`);
	};

	handleBusyInfo = () => {
		this.setState({
			showBusyModal: true,
		});
	};
	render() {
		let busyEqs = [];
		_.map(this.state.equipments, (eq, key) => {
			if (
				_.has(eq, 'qrCode') &&
				!eq.qrCode.includes('UNREGISTEREDEQ') &&
				_.size(
					_.filter(this.state.eventDetails.equipments, {
						qrCode: eq.qrCode,
					}),
				) == 0
			) {
				busyEqs.push(eq);
			}
		});
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container">
						<div className="arc-header">
							{/* <div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div> */}
							<div className="arch-item">
								<span>Workspace</span>
								<b>{this.props.params.workspaceID}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Project</span>
								<b>{this.state.eventDetails.projectTitle}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Shoot</span>
								<b>{this.state.eventDetails.name}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Receive Equipment</span>
							</div>
						</div>
						<div className="arc-body" style={{ flexDirection: 'row-reverse' }}>
							<div className="arcb-left">
								<div
									className="qrhitem column-20w"
									style={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<input
										value={this.state.qrCode}
										placeholder="Type QR Code"
										autoFocus={true}
										onChange={(e) => this.handleEventChange(e, 'qrCode')}
									/>
									{this.state.isEQFetching ? (
										<div className={'loading-btn'}>
											<LoadingBar />
										</div>
									) : (
										''
									)}
									{this.state.qrCodeError ? (
										<p>{this.state.qrCodeErrorMessage}</p>
									) : (
										''
									)}
									{/* {this.state.qrCodeError ? (
                                        <p>Equipment not found</p>
                                    ) : (
                                        ''
                                    )}
                                    {this.state.qrCodeDuplicate ? (
                                        <p>Equipment already scanned</p>
                                    ) : (
                                        ''
                                    )}
                                    {this.state.receiveError ? (
                                        <p>
                                            Equipment cannot be received as it
                                            is in ready state
                                        </p>
                                    ) : (
                                        ''
                                    )} */}
								</div>
								<div className="arcbl-list">
									<div className="assign-hdd-item ">
										<div className="column column-20w">
											<span>QR Code</span>
											<span>Branch</span>
											<span>Serial Number</span>
											<span>description</span>

											<span></span>

											{/* <span>damage</span> */}
										</div>

										{_.size(this.state.equipments) > 0 ? (
											_.map(
												this.state.equipments,

												(equipment, key) => {
													let isBusy = false;
													if (
														_.has(equipment, 'qrCode') &&
														!equipment.qrCode.includes(
															'UNREGISTEREDEQ',
														) &&
														_.find(busyEqs, {
															qrCode: equipment.qrCode,
														})
													) {
														isBusy = true;
													}
													return (
														<div
															className="hitem column-20w listHitem"
															style={{
																color: isBusy ? 'orange' : '#fff',
															}}
														>
															<span
																style={{
																	display: 'flex',
																	alignItems: 'center',
																}}
																onClick={(e) =>
																	isBusy && this.handleBusyInfo(e)
																}
															>
																{_.has(equipment, 'qrCode') &&
																equipment.qrCode.includes(
																	'UNREGISTEREDEQ',
																)
																	? ''
																	: equipment.qrCode}
																{isBusy ? (
																	<b
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			marginLeft: 5,
																		}}
																		className={'orange-info'}
																	>
																		<Info />
																	</b>
																) : (
																	''
																)}
															</span>
															<span
																onClick={(e) =>
																	isBusy && this.handleBusyInfo(e)
																}
															>
																{equipment.branch?.branchId ||
																	'VEHYD'}
															</span>
															<span
																onClick={(e) =>
																	isBusy && this.handleBusyInfo(e)
																}
															>
																{equipment.manufacturerId}
															</span>
															<span
																onClick={(e) =>
																	isBusy && this.handleBusyInfo(e)
																}
															>
																{equipment.description}
															</span>

															<span
																style={{
																	cursor: 'pointer',
																}}
																onClick={(e) =>
																	this.deleteItem(
																		e,
																		_.has(
																			equipment,
																			'qrCode',
																		) && equipment.qrCode,
																	)
																}
															>
																{' '}
																<Delete />
															</span>
														</div>
													);
												},
											)
										) : (
											<div className="empty">
												<p>
													No Equipment Added <br />
													Please scan or type in the equipment ID
												</p>
											</div>
										)}
									</div>
								</div>
								<div className="btn">
									<a
										className={
											this.isDisabled()
												? 'add-edit-btn disabled'
												: 'add-edit-btn'
										}
										onClick={(e) => {
											if (!this.isDisabled()) {
												this.handleAssignEquipment();
											}
										}}
									>
										Receive Equipment
									</a>
								</div>
							</div>
							<div className="arcb-right">
								{/* <div className="arcbr-top-inputs">
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Workspace</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.props.params.workspaceID}
												//value={this.props.params.workspaceID}
												isDisabled={true}
											/>
										</div>
									</div>

									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Project</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.projectTitle}
												isDisabled={true}
											/>
										</div>
									</div>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Event</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.name}
												isDisabled={true}
											/>
										</div>
									</div>
								</div> */}
								<div className="arcbr-bottom-inputs" style={{ marginTop: 0 }}>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Received From</label>
											{this.renderCrew()}
										</div>
									</div>
								</div>

								<div className="summary">{this.renderSummary()}</div>
							</div>
						</div>
						{this.state.showBusyModal === false ? null : (
							<Modal
								handleClose={() => this.setState({ showBusyModal: false })}
								show={this.state.showBusyModal}
								modalType={'center'}
							>
								<div className="busy-modal">
									<div className="bm-header">EQUIPMENT Error</div>
									<div className="bm-body">
										<div
											style={{
												maxHeight: '80%',
												width: '100%',
												overflowY: 'scroll',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<div
												style={{
													width: '100%',

													display: 'flex',
													flexDirection: 'row',
												}}
											>
												<span
													style={{
														width: '20%',
														color: '#707070',
														borderBottom: '1px solid #707070',
														paddingBottom: 5,
													}}
												>
													QR Code
												</span>
												<span
													style={{
														width: '20%',
														color: '#707070',
														borderBottom: '1px solid #707070',
														paddingBottom: 5,
													}}
												>
													Description
												</span>
												<span
													style={{
														width: '20%',
														color: '#707070',
														borderBottom: '1px solid #707070',
														paddingBottom: 5,
													}}
												>
													Project Name
												</span>
												<span
													style={{
														width: '20%',
														color: '#707070',
														borderBottom: '1px solid #707070',
														paddingBottom: 5,
													}}
												>
													Event Name
												</span>
												<span
													style={{
														width: '15%',
														color: '#707070',
														borderBottom: '1px solid #707070',
														paddingBottom: 5,
													}}
												>
													Status
												</span>
											</div>
											{_.map(busyEqs, (eq, k) => {
												return (
													<div
														style={{
															width: '100%',
															display: 'flex',
															flexDirection: 'row',
															margin: '5px 0px',
														}}
													>
														<span
															style={{
																width: '20%',
																color: '#fff',
																paddingRight: '8px',
															}}
														>
															{eq.qrCode}
														</span>
														<span
															style={{
																width: '20%',
																color: '#fff',
																paddingRight: '8px',
															}}
														>
															{eq.description}
														</span>
														<span
															style={{
																width: '20%',
																color: '#fff',
																paddingRight: '8px',
															}}
														>
															{eq.status === 'busy' &&
															_.has(eq.lastUsedBy, 'projectName')
																? eq.lastUsedBy.projectName
																: ''}
														</span>
														<span
															style={{
																width: '20%',
																color: '#fff',
																paddingRight: '8px',
															}}
														>
															{eq.status === 'busy' &&
															_.has(eq.lastUsedBy, 'eventName')
																? eq.lastUsedBy.eventName
																: ''}
														</span>
														<span
															style={{
																width: '20%',
																color: '#fff',
															}}
														>
															{eq.status
																? _.capitalize(eq.status)
																: ''}
														</span>
													</div>
												);
											})}
										</div>
										<p>
											{_.size(busyEqs)} Equipment
											{`${_.size(busyEqs) > 1 ? 's' : ''}`} are not assigned
											to this shoot. Do you still wish to go ahead and receive
											them for this shoot?
										</p>
									</div>
									<div className="bm-footer">
										<a
											onClick={() =>
												this.setState({
													showBusyModal: false,
												})
											}
										>
											No, Cancel
										</a>
										<a
											onClick={() =>
												this.setState({
													showBusyModal: false,
													confirmRemap: true,
												})
											}
											style={{
												margin: '0px 15px',
												background:
													'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
												color: '#fff',
											}}
										>
											Yes, Receive
										</a>
									</div>
								</div>
							</Modal>
						)}
					</div>
				)}
			</>
		);
	}
}

export default withRouter(AsssignEquipment);
